import { render, staticRenderFns } from "./FAQQQ.vue?vue&type=template&id=39f7b33c"
import script from "./FAQQQ.vue?vue&type=script&lang=js"
export * from "./FAQQQ.vue?vue&type=script&lang=js"
import style0 from "./FAQQQ.vue?vue&type=style&index=0&id=39f7b33c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports